import { useNavigate, useSearch } from '@tanstack/react-router';
import useFilters from './useFilters';

const useSearchFilters = () => {
    const search = useSearch({});
    const navigate = useNavigate();
    const filters = useFilters({
        filters: search,
        onChange: newFilters => navigate({ search: newFilters }),
    });
    return filters;
};

export default useSearchFilters;
